// extracted by mini-css-extract-plugin
export default {"container":"jNOP7GC8Lu18y8rdHv6T","form":"VYih9VQMtCWJdbN_tqiL","eraseButton":"RhOZ61QXbQzWnuyqCJGL","searchButton":"cmwW6s72Gt_0A1dWhYpx","searchInput":"sDUZXzhgZoNCniVCMVUB"};